module.exports = __webpack_public_path__ + "static/media/tresseme.5a235959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/tresseme.png
// module id = 971
// module chunks = 0